import { DigitalProductId } from 'modules/digital-product/types/digital-product-interface'
import {
  OfferFormEditType,
  OfferFormViewInterface,
} from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/offer-form-interface'
import { PhysicalProductId } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/physical-offer-interface'

export const getOfferSettingsApiData = (
  offerState: OfferFormViewInterface['offer'],
): OfferFormEditType => {
  const saleLimit: OfferFormEditType['saleLimit'] = offerState.saleLimit

  const affiliateCommission: OfferFormEditType['affiliateCommission'] =
    offerState.affiliateCommission

  const payoutDelay: OfferFormEditType['payoutDelay'] = offerState.payoutDelay

  const saleLimitFunnelStepRedirect: OfferFormEditType['saleLimitFunnelStepRedirect'] =
    offerState.saleLimitFunnelStepRedirect?.id

  const coupons: OfferFormEditType['coupons'] = offerState.coupons?.map(coupon => coupon.id) || []

  // Only one bump per offer is supported, and a bump without a product does not exist.
  const bumpView = offerState.bumps.length !== 0 ? offerState.bumps[0] : undefined

  const digitalProductBump: DigitalProductId | null = bumpView?.digitalProduct?.id ?? null

  const productBump: PhysicalProductId | null = bumpView?.product?.id ?? null

  const bumps: OfferFormEditType['bumps'] = digitalProductBump
    ? [{ digitalProduct: digitalProductBump, product: null }]
    : productBump
      ? [{ product: productBump, digitalProduct: null }]
      : []

  const digitalProduct: OfferFormEditType['digitalProduct'] = offerState.digitalProduct?.id || null

  const product: OfferFormEditType['product'] = offerState.product?.id || null

  const baseOffer = {
    saleLimit,
    payoutDelay,
    affiliateCommission,
    saleLimitFunnelStepRedirect,
    coupons,
    bumps,
  }

  if (digitalProduct) {
    return {
      ...baseOffer,
      digitalProduct,
      product: null,
    }
  } else {
    return {
      ...baseOffer,
      digitalProduct: null,
      product,
    }
  }
}
